<script lang="ts">
  import { ControlFrameHost, InternalAssistMount } from "@kontextwerk/control-web-frame"
  import { adminSession } from "@kontextwerk/control-web-frame/authentication/session"
  import { derived } from "svelte/store"
  import { location } from "../../_shared/_logic/store"
  import { controlFrameConfig } from "./frameConfig"
  import { shouldShowInternalAssistForPath } from "./_logic/internalAssistVisibility"
  import { buildAppPermissionState } from "../_shared/_logic/permissions-model"
  import { setKehrblattControlAuthContext } from "../_shared/_logic/auth-context"
  import CustomerImportStatusBannerMount from "./_modules/customer-import-status-banner-mount"

  setKehrblattControlAuthContext(
    derived(adminSession, ($adminSession) => ({
      session: $adminSession ?? null,
      user: $adminSession?.user ?? null,
      permissions: buildAppPermissionState($adminSession),
      currentUserId: $adminSession?.user?.id ?? null,
      currentUserRole: $adminSession?.user?.role ?? null,
      currentUserOrganizationId: $adminSession?.user?.organization_id ?? null,
    })),
  )

  const showInternalAssist = $derived(shouldShowInternalAssistForPath($location.path))
</script>

<ControlFrameHost config={controlFrameConfig} />
{#if showInternalAssist}
  <InternalAssistMount />
{/if}
<CustomerImportStatusBannerMount />
